// SparkleIcon.tsx
import React from 'react';

const SparkleIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_10218_31585)">
      <path
        d="M1.89053 4.05715C2.25609 3.80165 2.80714 3.85065 3.13537 4.12171L2.75892 3.57454C2.45598 3.14249 2.56448 2.67504 2.99692 2.37171C3.42937 2.06954 4.65475 2.88193 4.65475 2.88193C4.34909 2.4456 4.40625 1.8926 4.84259 1.58654C5.27892 1.28165 5.88092 1.38704 6.18659 1.82415L10.2388 7.5486L9.72237 12.5555L5.41231 10.9837L1.65292 5.40971C1.34453 4.97065 1.45109 4.36515 1.89053 4.05715Z"
        fill="#EF9645"
      />
      <path
        d="M1.04566 7.24173C1.04566 7.24173 0.605433 6.60006 1.24749 6.16023C1.88877 5.72039 2.3286 6.36167 2.3286 6.36167L4.37066 9.33978C4.44104 9.22234 4.51804 9.10645 4.60399 8.99212L1.76977 4.85939C1.76977 4.85939 1.32993 4.21812 1.9716 3.77828C2.61288 3.33845 3.05271 3.97973 3.05271 3.97973L5.71854 7.86745C5.81771 7.78656 5.91921 7.70528 6.02382 7.62556L2.93332 3.11795C2.93332 3.11795 2.49349 2.47667 3.13516 2.03684C3.77643 1.59701 4.21627 2.23828 4.21627 2.23828L7.30677 6.74512C7.42032 6.67551 7.53271 6.61523 7.64549 6.55145L4.75682 2.33901C4.75682 2.33901 4.31699 1.69773 4.95827 1.25789C5.59954 0.818061 6.03938 1.45934 6.03938 1.45934L9.09371 5.91367L9.55804 6.59112C7.63382 7.91101 7.45066 10.3941 8.55005 11.9974C8.76977 12.3183 9.0906 12.0986 9.0906 12.0986C7.7711 10.174 8.17399 8.01134 10.0986 6.69184L9.53121 3.85217C9.53121 3.85217 9.31927 3.10395 10.0671 2.89162C10.8153 2.67967 11.0277 3.42789 11.0277 3.42789L11.6829 5.37389C11.9427 6.14545 12.2192 6.91428 12.5852 7.64151C13.6184 9.69484 13.0013 12.2467 11.0529 13.5833C8.92766 15.0405 6.02227 14.4988 4.56471 12.3739L1.04566 7.24173Z"
        fill="#FFDC5D"
      />
      <path
        d="M4.66694 12.9609C3.11139 12.9609 1.5395 11.389 1.5395 9.83347C1.5395 9.61841 1.382 9.44458 1.16694 9.44458C0.951885 9.44458 0.761719 9.61841 0.761719 9.83347C0.761719 12.1668 2.33361 13.7387 4.66694 13.7387C4.882 13.7387 5.05583 13.5485 5.05583 13.3335C5.05583 13.1184 4.882 12.9609 4.66694 12.9609Z"
        fill="#5DADEC"
      />
      <path
        d="M2.72222 13.7223C1.55556 13.7223 0.777778 12.9445 0.777778 11.7778C0.777778 11.5628 0.603944 11.3889 0.388889 11.3889C0.173833 11.3889 0 11.5628 0 11.7778C0 13.3334 1.16667 14.5001 2.72222 14.5001C2.93728 14.5001 3.11111 14.3262 3.11111 14.1112C3.11111 13.8961 2.93728 13.7223 2.72222 13.7223ZM9.33333 1.27783C9.11867 1.27783 8.94444 1.45205 8.94444 1.66672C8.94444 1.88139 9.11867 2.05561 9.33333 2.05561C10.8889 2.05561 12.4444 3.45133 12.4444 5.16672C12.4444 5.38139 12.6187 5.55561 12.8333 5.55561C13.048 5.55561 13.2222 5.38139 13.2222 5.16672C13.2222 3.02239 11.6667 1.27783 9.33333 1.27783Z"
        fill="#5DADEC"
      />
      <path
        d="M11.2795 0.516357C11.0648 0.516357 10.8906 0.674246 10.8906 0.888913C10.8906 1.10358 11.0648 1.29414 11.2795 1.29414C12.4462 1.29414 13.2076 2.15941 13.2076 3.22225C13.2076 3.43691 13.3978 3.61114 13.6128 3.61114C13.8279 3.61114 13.9854 3.43691 13.9854 3.22225C13.9854 1.73008 12.8351 0.516357 11.2795 0.516357Z"
        fill="#5DADEC"
      />
    </g>
    <defs>
      <clipPath id="clip0_10218_31585">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SparkleIcon;
